import React, { createContext, useContext, useReducer } from 'react';

const AuthContext = createContext();

const initialState = {
    isAuthenticated: JSON.parse(localStorage.getItem('isAuthenticated')) || false
};

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { isAuthenticated: true };
        case 'LOGOUT':
            return { isAuthenticated: false};
        default:
            return state;
    }
};

const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, initialState);

    const login = () => {
        localStorage.setItem('isAuthenticated', true);

        dispatch({ type: 'LOGIN' });
    }

    const logout = () => {
        localStorage.setItem('isAuthenticated', false);

        dispatch({ type: 'LOGOUT' });
    }

    return (
        <AuthContext.Provider value={{ ...state, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export { AuthProvider, useAuth };
